import { motion } from 'framer-motion';
import { LINKS } from '../config';

export function CtaBanner() {
  return (
    <section className="relative overflow-hidden border-t border-white/[0.05] bg-midnight-950 py-28">
      <div className="absolute inset-0 bg-aurora opacity-70" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto max-w-2xl px-6 text-center"
      >
        <h2 className="text-balance text-3xl sm:text-4xl">
          Your keys. Your Midnight. <span className="italic text-teal-soft">Your call.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-balance text-base leading-relaxed text-mist">
          Add Vela to Chrome and hold your own keys in under a minute.
        </p>
        <a
          href={LINKS.chromeWebStore}
          className="mt-8 inline-flex items-center justify-center gap-2.5 rounded-full bg-teal px-7 py-3.5 font-medium text-midnight-950 shadow-glow transition-transform hover:scale-[1.02] active:scale-[0.98]"
        >
          Add Vela to Chrome
          <span aria-hidden="true">→</span>
        </a>
      </motion.div>
    </section>
  );
}
